import { useAccountCompanyId } from 'application/hooks';
import useBindCard from '@entities/paymentMethod/api/useBindCard';

const useCardBindModalPresenter = () => {
  const companyId = useAccountCompanyId();

  const { request: getLinkForBindingCardRequest, result: bindCardResult } = useBindCard();

  const getLinkForBindingCard = async (pathname: string) => {
    const link = await getLinkForBindingCardRequest(pathname, companyId);

    return link;
  };

  return {
    getLinkForBindingCard,
    bindCardLoading: bindCardResult.loading,
  };
};

export default useCardBindModalPresenter;
